export default "__VITE_ASSET__Dm0RCQ4v__"